"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkFloater = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const PositionAtPoint_1 = require("@jsonjoy.com/ui/lib/utils/popup/PositionAtPoint");
const useClickAway_1 = require("@jsonjoy.com/ui/lib/hooks/useClickAway");
const context_1 = require("../../context");
const LinkToolbarPopup_1 = require("./LinkToolbarPopup");
const context_2 = require("./context");
const GAP = 8;
const pointFromRect = (rect) => {
    const x = rect.left + rect.width / 2;
    const spaceBelow = window.innerHeight - rect.bottom;
    const spaceAbove = rect.top;
    if (spaceBelow >= spaceAbove) {
        return { x, y: rect.bottom + GAP, dx: 0, dy: 1 };
    }
    return { x, y: rect.top - GAP, dx: 0, dy: -1 };
};
const LinkFloater = () => {
    const mutxt = (0, context_1.useMuTxt)();
    const link = mutxt.inline.link;
    const open = link.open.use();
    const rect = link.anchorRect.use();
    const clickAwayRef = (0, useClickAway_1.useClickAway)(React.useCallback(() => link.close(), [link]));
    if (!open || !rect)
        return null;
    const point = pointFromRect(rect);
    return (React.createElement(context_2.ctx.Provider, { value: link },
        React.createElement(PositionAtPoint_1.PositionAtPoint, { point: point },
            React.createElement("div", { ref: clickAwayRef, onMouseDown: (e) => {
                    if (e.target.tagName !== 'INPUT')
                        e.preventDefault();
                }, onKeyDown: (e) => {
                    if (e.key === 'Escape') {
                        e.stopPropagation();
                        e.preventDefault();
                        link.close();
                    }
                } },
                React.createElement(LinkToolbarPopup_1.LinkToolbarPopup, null)))));
};
exports.LinkFloater = LinkFloater;
